<template>
  <base-modal-ex :active.sync="active"
    :animation-in="animationIn"
    :animation-out="animationOut"
    :animation-duration="animationDuration"
    :can-cancel="false"
    :min-width="80"
    has-modal-card>
    <header class="modal-card-head">
      <p class="modal-card-title">Contacts</p>
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div class="column is-two-thirds">
          <div class="field">
            <label class="label">Title</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="contact.title">
                  <option value="null"
                    disabled>Select</option>
                  <option v-for="(name, code) in salutes"
                    :key="code"
                    :value="name">
                    {{ name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">First Name</label>
            <div class="control">
              <input class="input"
                v-model="contact.firstName"
                type="text"
                :class="{ 'is-danger' : $v.contact.firstName.$error }"
                @input="$v.contact.firstName.$touch()">
              <span class="help is-danger"
                v-if="! $v.contact.firstName.required">First Name is required</span>
            </div>
          </div>
          <div class="field">
            <label class="label">Last Name</label>
            <div class="control">
              <input class="input"
                v-model="contact.lastName"
                type="text"
                :class="{ 'is-danger' : $v.contact.lastName.$error }"
                @input="$v.contact.lastName.$touch()">
              <span class="help is-danger"
                v-if="! $v.contact.lastName.required">Last Name is required</span>
            </div>
          </div>
          <div class="field">
            <company-asset-addresses ref="assetAddresses"
              :addresses="contact.addresses"
              :country-code="sortedAddresses?.countryCode??null"
              @removeAddress="removeAddress"
              @setDefault="setDefault"
              @addTmpAddress="addTmpAddress" />
          </div>
          <div class="field">
            <company-asset-phones ref="assetPhones"
              :phones="activePhones"
              @removePhone="removePhone"
              @setDefault="setDefault"
              @addTmpPhone="addTmpPhone"
              @validationChanged="onRefsValidationChanged" />
          </div>
          <div class="field">
            <company-asset-emails ref="assetEmails"
              :emails="activeEmails"
              @removeEmail="removeEmail"
              @setDefault="setDefault"
              @addTmpEmail="addTmpEmail"
              @validationChanged="onRefsValidationChanged" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Contents</label>
            <p class="control">
              <textarea class="textarea"
                v-model="contact.remarks.remarks"
                @change="contact.remarks.isDirty = true" />
            </p>
          </div>

          <div class="field">
            <p class="control">
              <a class="button is-primary"
                @click="showRecurringRemark">
                <span class="icon is-small">
                  <i class="mdi mdi-repeat" />
                </span>
                <span> Recurring Remarks</span>
              </a>
            </p>
          </div>

          <div class="field">
            <label class="label">Alert?</label>
            <div class="control">
              <input id="alert"
                name="alert"
                class="switch is-rounded"
                type="checkbox"
                v-model="contact.isAlert">
              <label for="alert" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot is-flex is-justify-content-flex-end">
      <div class="buttons">

        <button class="button tooltip is-primary"
          data-tooltip="Save"
          :disabled="validationErrors"
          @click="save">
          <span class="icon">
            <span class="mso mso-20px mso-fill">
              save
            </span>
          </span>
          <span>Save</span>
        </button>
        <button class="button tooltip"
          @click="close"
          data-tooltip="Cancel">
          <span class="icon">
            <span class="mso mso-20px">
              close
            </span>
          </span>
          <span>Cancel</span>
        </button>
      </div>
    </footer>
  </base-modal-ex>
</template>

<script>
import { BaseModalEx } from '@/components/BulmaModal'
import { Salutation } from '../../../enums'
import CompanyAssetAddresses from './CompanyAssetAddresses.vue'
import { AddressModel, EmailModel, PhoneModel } from '../../../classes/viewmodels'
import CompanyAssetPhones from './CompanyAssetPhones.vue'
import CompanyAssetEmails from './CompanyAssetEmails.vue'
import Vue from 'vue'
import RecurringRemarkModal from '@/views/recurringremarks/RecurringRemarkModal'
import { required } from 'vuelidate/lib/validators'

const RecurringRemarkComponent = Vue.extend(RecurringRemarkModal)

export default {
  name: 'ContactModal',
  components: {
    BaseModalEx,
    CompanyAssetAddresses,
    CompanyAssetPhones,
    CompanyAssetEmails
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object,
      default: () => ({})
    },
    animationIn: {
      type: String,
      default: 'zoomIn'
    },
    animationOut: {
      type: String,
      default: 'zoomOut'
    },
    animationDuration: {
      type: [String, Number],
      default: 0.3
    }
  },
  data() {
    return {
      cardModal: null,
      refsHasError: false
    }
  },
  computed: {
    salutes() {
      return Salutation
    },
    sortedAddresses() {
      if (this.contact && this.contact.addresses) {
        return [...this.contact.addresses].sort((a, b) => b.isDefault - a.isDefault)
      }
    },
    validationErrors() {
      return (
        this.$v.contact.$error ||
        (this.$refs.assetAddresses && this.$refs.assetAddresses.$v && this.$refs.assetAddresses.$v.$error) ||
        (this.$refs.assetPhones && this.$refs.assetPhones.$v && this.$refs.assetPhones.$v.$error) ||
        (this.$refs.assetEmails && this.$refs.assetEmails.$v && this.$refs.assetEmails.$v.$error) ||
        this.refsHasError
      )
    },
    activePhones() {
      if (this.contact && this.contact.phones) {
        return [...this.contact.phones].filter((a) => !a.isDeleted)
      }
    },
    activeEmails() {
      if (this.contact && this.contact.emails) {
        return [...this.contact.emails].filter((a) => !a.isDeleted)
      }
    }
  },
  mounted() {
    this.$v.$touch()
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save', this.contact)
    },
    setDefault(asset, assetType) {
      const typeMap = {
        assetEmails: 'emails',
        assetPhones: 'phones',
        assetAddresses: 'addresses'
      }
      const key = typeMap[assetType] || assetType
      if (this.contact[key] && Array.isArray(this.contact[key])) {
        this.contact[key].forEach((a) => {
          a.isDefault = a === asset
        })
      }
      // this.contact[assetType].forEach((a) => (a.isDefault = a == asset))
    },
    addTmpAddress() {
      let newAddress = new AddressModel(this.contact.companyId)
      if (this.contact.addresses.length == 0) {
        newAddress.isDefault = true
        newAddress.isNew = true
      }
      this.contact.addresses.push(newAddress)
    },
    addTmpPhone() {
      let newPhone = new PhoneModel()
      if (this.contact.phones.length == 0) {
        newPhone.isDefault = true
        newPhone.isNew = true
      }
      this.contact.phones.push(newPhone)
    },
    addTmpEmail() {
      let newEmail = new EmailModel()
      if (this.contact.emails.length == 0) {
        newEmail.isDefault = true
        newEmail.isNew = true
      }
      this.contact.emails.push(newEmail)
    },
    removeAddress(address) {
      // this.contact.addresses = this.contact.addresses.filter((a) => a !== address)
      const idx = this.contact.addresses.findIndex((a) => a === address)
      if (idx !== -1) {
        if (!address.isNew && address.id) {
          this.contact.addresses[idx].isDeleted = true
        } else {
          this.contact.addresses.splice(idx, 1)
        }
      }
    },
    removePhone(phone) {
      //this.contact.phones = this.contact.phones.filter((p) => p !== phone)
      const idx = this.contact.phones.findIndex((a) => a === phone)
      if (idx !== -1) {
        if (!phone.isNew && phone.id) {
          this.contact.phones[idx].isDeleted = true
        } else {
          this.contact.phones.splice(idx, 1)
        }
      }
    },
    removeEmail(email) {
      // this.contact.emails = this.contact.emails.filter((e) => e !== email)
      const idx = this.contact.emails.findIndex((a) => a === email)
      if (idx !== -1) {
        if (!email.isNew && email.id) {
          this.contact.emails[idx].isDeleted = true
        } else {
          this.contact.emails.splice(idx, 1)
        }
      }
    },
    showRecurringRemark() {
      this.cardModal = new RecurringRemarkComponent({
        el: document.createElement('div'),
        propsData: {
          visible: false
        }
      }).$on('ok', (res) => {
        this.contact.remarks.remarks = res + '\n' + this.contact.remarks.remarks
        this.contact.remarks.isDirty = true
      })

      this.cardModal.visible = true
    },
    onRefsValidationChanged(hasError) {
      this.refsHasError = hasError
    }
  },
  validations() {
    return {
      contact: {
        firstName: { required },
        lastName: { required }
      }
    }
  }
}
</script>
